export default "__VITE_ASSET__BT0tt_e2__"